import keymirror from 'keymirror';
/**
 * App action types
 *
 */
export const appActionTypes = keymirror({
  SAVE_FRP_ID: null,
  SAVE_FUNDRAISING_PREFERENCES: null,
  FATAL_ERROR: null,
  SAVE_CAUSE: null,
  SAVE_EVENT: null,
  SEE_MORE_EVENTS: null,
  RESET_SEE_MORE_EVENTS_PAGE_INDEX: null,
  SHOW_INLINE_ALERT: null,
  CLOSE_INLINE_ALERT: null,
  SAVE_TEAM_SETTINGS_DATA: null,
  SAVE_STORY_DATA: null,
  SELECT_FUNDRAISING_PAGE: null,
  SAVE_TEAM_GUID: null,
  EDIT_TEAM_DATA: null,
  ANALYTICS_TRACK: null,
  SAVE_NEW_FRP_DATA: null,
});

export const httpActionTypes = keymirror({
  REQUEST_MADE: null,
  REQUEST_SUCCESS: null,
  REQUEST_ERROR: null,
  REQUEST_RESET: null,
});

export const apiActionTypes = keymirror({
  SAVE_FRP_DATA: null,
  SAVE_TEAM_ID: null,
  SAVE_TEAM_NAME: null,
  SAVE_GDPR_CONSENTS: null,
  SAVE_UPLOADED_COVER_PHOTO: null,
  IS_SHORT_NAME_VALID: null,
  SAVE_GIFT_AID_PREFERENCES: null,
  CLEAR_SHORT_NAME_VALIDITY: null,
  SAVE_EVENT_DETAILS: null,
  SAVE_FUNDRAISING_PAGES: null,
  SAVE_MEMBERS_LIST_DATA: null,
  SAVE_MEMBERSHIP_POLICY: null,
  SAVE_TEAM_MEMBER_TARGET_AMOUNT: null,
  TEAM_REQUEST_MADE: null,
  TEAM_REQUEST_SUCCESS: null,
  TEAM_REQUEST_ERROR: null,
  LOCKS_REQUEST_MADE: null,
  LOCKS_REQUEST_SUCCESS: null,
  LOCKS_REQUEST_ERROR: null,
  CREATE_EVENT_REQUEST_MADE: null,
  CREATE_EVENT_REQUEST_SUCCESS: null,
  CREATE_EVENT_REQUEST_ERROR: null,
  GET_EVENT_REQUEST_MADE: null,
  GET_EVENT_REQUEST_SUCCESS: null,
  GET_EVENT_REQUEST_ERROR: null,
  GET_APP_DATA_REQUEST_MADE: null,
  GET_APP_DATA_REQUEST_SUCCESS: null,
  GET_APP_DATA_REQUEST_ERROR: null,
  GET_FUNDRAISING_PAGES_REQUEST_MADE: null,
  GET_FUNDRAISING_PAGES_REQUEST_SUCCESS: null,
  GET_FUNDRAISING_PAGES_REQUEST_ERROR: null,
  GET_CHARITY_DATA_REQUEST_MADE: null,
  GET_CHARITY_DATA_REQUEST_SUCCESS: null,
  GET_CHARITY_DATA_REQUEST_ERROR: null,
  CREATE_TEAM_REQUEST_MADE: null,
  CREATE_TEAM_REQUEST_SUCCESS: null,
  CREATE_TEAM_REQUEST_ERROR: null,
  SUBMIT_TEAM_NAME_REQUEST_MADE: null,
  SUBMIT_TEAM_NAME_REQUEST_SUCCESS: null,
  SUBMIT_TEAM_NAME_REQUEST_ERROR: null,
  UPDATE_LOCKS_REQUEST_MADE: null,
  UPDATE_LOCKS_REQUEST_ERROR: null,
  UPDATE_LOCKS_REQUEST_SUCCESS: null,
  UPDATE_NUMBER_OF_MEMBERS: null,
  SUBMIT_TEAM_DATA_REQUEST_MADE: null,
  SUBMIT_TEAM_DATA_REQUEST_ERROR: null,
  SUBMIT_TEAM_DATA_REQUEST_SUCCESS: null,
});
